<div echarts [options]="chartOptions()" class="ogive-chart"></div>
